import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import classnames from 'classnames'
import colors from 'styles/colors'

import style from './style.styl'

const DEFAULT_WIDTH = 13.6

export function getColor(percent) {
  if (percent >= 90) {
    return colors['color-orange']
  } else {
    return colors['color-green']
  }
}

class QuotaBar extends PureComponent {
  static propTypes = {
    percent: PropTypes.number.isRequired,
    totalWidth: PropTypes.number,
  }

  getWidth() {
    return this.props.totalWidth || DEFAULT_WIDTH
  }

  render() {
    const { percent, light } = this.props
    const color = getColor(percent)
    const width = `${this.getWidth() * percent / 100}rem`
    return (
      <div className={classnames(style.CounterContainer, { light: light })} style={{ width: `${this.getWidth()}rem` }}>
        <ReactCSSTransitionGroup
          transitionName="counter-grow"
          transitionAppear={true}
          transitionEnterTimeout={3000}
          transitionLeaveTimeout={1000}
          transitionAppearTimeout={250}
        >
          <div className={style.Counter} style={{ width, backgroundColor: color }} />
        </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default QuotaBar



// WEBPACK FOOTER //
// ./src/scripts/components/shared/QuotaBar/index.js